<template>
  <div :class="{up:!showSearch}" class="opera-btn-group">
    <div class="opera-icon">
<!--        <span class="pull-right" style="margin-left: 10px">-->
<!--          <perm class="pull-right" label="biz-codes-file-upload">-->
<!--              <el-button @click="add" native-type="submit" type="primary"><i class="el-icon-t-plus"/>添加</el-button>-->
<!--          </perm>-->
<!--        </span>-->
      <span class="pull-right" style="margin-left: 10px">
          <perm class="pull-right" label="biz-codes-file-batch-upload">
              <el-button @click="batchAddAli" native-type="submit" type="primary"><i class="el-icon-t-plus"/>批量上传业务数据XML</el-button>
          </perm>
        </span>
        <span class="pull-right" style="margin-left: 10px">
          <perm class="pull-right" label="biz-codes-file-batch-out-add">
              <el-button @click="addBatchOut" native-type="submit" type="primary"><i class="el-icon-t-plus"/>整批出库</el-button>
          </perm>
        </span>
        <span class="pull-right" style="margin-left: 10px">
          <perm class="pull-right" label="biz-codes-file-upload-xml">
              <el-button @click="addAli" native-type="submit" type="primary"><i class="el-icon-t-plus"/>上传业务数据XML</el-button>
          </perm>
        </span>
        <span class="pull-right" style="margin-left: 10px">
          <perm class="pull-right" label="biz-codes-file-order-add">
              <el-button @click="addOrder" native-type="submit" type="primary"><i class="el-icon-t-plus"/>新增订单</el-button>
          </perm>
        </span>
        <span class="pull-right" style="margin-left: 10px">
          <perm class="pull-right" label="biz-codes-file-upload-order">
              <el-button @click="batchAddBatchOut" native-type="submit" type="primary"><i class="el-icon-t-plus"/>上传Excel新增订单</el-button>
          </perm>
        </span>
    </div>
    <el-form class="advanced-query-form">
      <el-row>
        <el-col :span="8">
          <oms-form-row :span="5" label="业务单据号">
            <oms-input placeholder="请输入业务单据号" type="text" v-model="searchCondition.objectNo"></oms-input>
          </oms-form-row>
        </el-col>
        <el-col :span="10">
          <oms-form-row :span="5" label="业务时间范围">
            <el-col :span="24">
              <el-date-picker
                v-model="times1"
                format="yyyy-MM-dd"
                placeholder="请选择" type="daterange">
              </el-date-picker>
            </el-col>
          </oms-form-row>
        </el-col>
        <el-col :span="6">
          <oms-form-row :span="6" label="业务类型">
            <el-select filterable placeholder="请选择业务类型" v-model="searchCondition.bizType">
              <el-option :key="item.key" :label="item.label" :value="item.key" v-for="item in BizTypes"/>
            </el-select>
          </oms-form-row>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="8">
          <oms-form-row :span="5" label="来源单位">
            <org-select :remote-method="queryDownList" placeholder="请输入名称/拼音首字母缩写/系统代码搜索来源单位"
                        v-model.trim="searchCondition.sourceOrgId" :list="downOrgList"/>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="去向单位">
            <org-select :remote-method="queryDownList" placeholder="请输入名称/拼音首字母缩写/系统代码搜索去向单位"
                        v-model.trim="searchCondition.directionOrgId" :list="downOrgList"/>
          </oms-form-row>
        </el-col>
        <el-col :span="6">
          <oms-form-row :span="6" label="状态">
            <el-select filterable placeholder="请选择业务类型" v-model="searchCondition.status">
              <el-option :key="k" :label="item.label" :value="k" v-for="(item,k) in bizTraceUploadStatus"/>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="7" label="">
            <el-button @click="search" plain type="primary">查询</el-button>
            <el-button @click="reset" native-type="reset">重置</el-button>
          </oms-form-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import methodsMixin from '@/mixins/methodsMixin';
  import {BaseInfo} from "@/resources";
  import DataMixin from '@/mixins/dataMixin';

  export default {
    mixins: [DataMixin,methodsMixin],
    data: function () {
      return {
        searchCondition: {
          orgId: '',
          objectNo: '',
          bizType: '',
          sourceOrgId: '',
          directionOrgId: '',
          operateStartTime: '',
          operateEndTime: ''
        },
        showSearch: false,
        list: [],
        times1: []
      };
    },
    computed:{
      BizTypes: function () {
        let bizTypes = this.$getDict('bspBizType') || [];
        return bizTypes;
      }
    },
    methods: {
      search() {
        this.searchCondition.operateStartTime = this.formatTimeAry(this.times1, 0);
        this.searchCondition.operateEndTime = this.formatTimeAry(this.times1, 1);
        // this.searchCondition.uploadStartTime = parent.formatTimeAry(this.times2, 0);
        // this.searchCondition.uploadEndTime = parent.formatTimeAry(this.times2, 1);
        this.$emit('search', this.searchCondition);
      },
      formatTimeAry(times, index, str) {
        if (!times) return;
        return this.formatTime(times[index], str);
      },
      formatTime(time, str = 'YYYY-MM-DD HH:mm:ss') {
        return time ? this.$moment(time).format(str) : '';
      },
      reset() {
        this.searchCondition = {
          orgId: '',
          objectNo: '',
          bizType: '',
          status: '',
          sourceOrgId: '',
          directionOrgId: '',
          operateStartTime: '',
          operateEndTime: ''
        };
        this.times1 = [];
        this.$emit('search', this.searchCondition);
      },
      queryDownList: function (query, success = () => {
      }) {// 查询来源单位
        let params = {};
        if (typeof query === 'string') {
          params = {keyWord: query}
        } else if (typeof query === 'object') {
          params = query;
        }
        BaseInfo.queryPager(params).then(res => {
          this.downOrgList = res.data.list;
          success();
        });
      },
      orgChange(val) {
        this.searchCondition.createdBy = '';
        this.queryOrgAccountList('searchCondition.uploadOrg')();
        this.orgUsers = [];
      },
      isShow(val) {
        this.showSearch = val;
      },
      add() {
        this.$emit('add');
      },
      addAli() {
        this.$emit('addAli');
      },
      batchAddAli() {
        this.$emit('batchAddAli');
      },
      addBatchOut() {
        this.$emit('addBatchOut');
      },
      batchAddBatchOut() {
        this.$emit('batchAddBatchOut');
      },
      addOrder() {
        this.$emit('addOrder');
      }
    }
  };
</script>
